const FileIconSize = {
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small",
  XLARGE: "xlarge",
} as const;

export { FileIconSize };
